/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { UserDeactivateModel } from '../../models/user-deactivate-model';

export interface UserDeleteParams {
  guid: string;
  body: UserDeactivateModel;
}

export function userDelete(
  http: HttpClient,
  rootUrl: string,
  params: UserDeleteParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userDelete.PATH, 'delete');

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  rb.path('guid', params.guid, { style: 'simple' });
  rb.body(params.body, 'application/json');

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => r as StrictHttpResponse<void>),
    );
}

userDelete.PATH = '/api/v1/users/{guid}';
